export const getChatConversationCount = (state) =>
    state.chat.conversations.maxCount
